import { FunctionComponent, useContext } from 'react'
import { useActor } from '@xstate/react'
import { CampaignContext } from '../src/state/CampaignContext'
import { formatPrice } from '../src/utils/priceUtils'
import { DonationInterpreter } from '../src/machines/donationMachine'
import { CustomDonationInput } from './CustomDonationInput'
import styles from './DonationGrid.module.css'

type Props = {
  service: DonationInterpreter
}

export const DonationGrid: FunctionComponent<Props> = ({ service }) => {
  const { offer } = useContext(CampaignContext)
  const [{ context }, send] = useActor(service)
  const { presets, presetDonation, customDonation } = context

  const savePresetDonation = (amount: number) =>
    send({ type: 'SAVE_PRESET', amount })

  const renderPreset = (preset: number) => {
    const checked = presetDonation === preset
    const labelClassName = `button ${styles.donationOption} ${
      checked ? styles.donationOptionChecked : ''
    }`

    return (
      <label className={labelClassName} key={preset}>
        <input
          checked={checked}
          type="radio"
          value={preset}
          onChange={() => savePresetDonation(preset)}
        />
        {formatPrice({ ...offer, price: preset })}
      </label>
    )
  }

  function renderCustom() {
    const checked = customDonation
    const labelClassName = `button ${styles.donationOption} ${
      checked ? styles.donationOptionChecked : ''
    }`

    return (
      <label className={labelClassName}>
        $
        <CustomDonationInput
          service={service}
          className={styles.donationOptionInput}
        />
      </label>
    )
  }

  return (
    <div className={styles.donationGrid}>
      {presets.map(renderPreset)}
      {renderCustom()}
    </div>
  )
}
